import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

import { has } from 'lodash-es';
import { Subscription } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  template: ''
})
export class GenericComponent implements OnDestroy {
  protected subscriptions: Subscription[] = [];
  protected uniqueSubscriptions: {
    [key: string]: Subscription;
  } = {};

  addUniqueSubscription(key: string, sub: Subscription) {
    this.cancelSubscription(key);
    this.uniqueSubscriptions[key] = sub;
  }

  cancelSubscription(key: string) {
    if (key in this.uniqueSubscriptions) {
      this.uniqueSubscriptions[key].unsubscribe();
    }
  }

  cancelAllSubscriptions() {
    while (this.subscriptions.length) {
      const subscription = this.subscriptions.pop();
      if (subscription) {
        subscription.unsubscribe();
      }
    }

    for (const key in this.uniqueSubscriptions) {
      if (has(this.uniqueSubscriptions, key)) {
        this.uniqueSubscriptions[key].unsubscribe();
      }
    }
    this.uniqueSubscriptions = {};
  }

  ngOnDestroy() {
    this.cancelAllSubscriptions();
  }

  ionViewDidLeave() {
    this.cancelAllSubscriptions();
  }
}
